import styled, { css } from 'styled-components';
import {
  px2rem,
  getSpace,
  gridContainer,
  setGridColumns,
  mq,
  getColor
} from '../../../../stylesheets/tools';

const StyledEducationCard = styled.div`
  ${props =>
    props.isNumbered &&
    css`
      display: flex;
    `}
  .card-number {
    padding-top: ${px2rem('20px')};
    max-width: 8rem;
    width: 100%;
    display: none;
    
    ${mq('l')} {
      display: block;
    }
    
    .card-number__square {
      margin-bottom: ${getSpace('xs')};
    }
  }

  .card {
    width: 100%;
    position: relative;
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    padding: ${px2rem('20px')};
    gap: ${px2rem('16px')};

    ${mq('m')} {
      gap: ${px2rem('24px')};
      ${setGridColumns('1fr', 10)}
    }

    &:hover,
    &:focus {
      cursor: pointer;
      background-position: top right, top right, bottom left, bottom left, top left;
      background-repeat: no-repeat;
      background-image: linear-gradient(180deg, currentColor, currentColor),
        linear-gradient(225deg, currentColor, currentColor),
        linear-gradient(0deg, currentColor, currentColor),
        linear-gradient(90deg, currentColor, currentColor),
        linear-gradient(
          135deg,
          transparent 18px,
          currentColor 18px,
          currentColor 20px,
          transparent 20px
        );
      background-size: calc(100% - 26px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 26px), 36px 36px;

      
      ${mq('m')} {
        background-image: linear-gradient(180deg, currentColor, currentColor),
          linear-gradient(225deg, currentColor, currentColor),
          linear-gradient(0deg, currentColor, currentColor),
          linear-gradient(90deg, currentColor, currentColor),
          linear-gradient(
            135deg,
            transparent 24px,
            currentColor 24px,
            currentColor 26px,
            transparent 26px
          );
        background-size: calc(100% - 34px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 34px), 36px 36px;
      }

      &:after {
        background-color: ${getColor('lightGray')};
        position: absolute;
        height: 100%;
        z-index: -2;
        width: 100%;
        content: '';
        clip-path: polygon(28px 0, 100% 0, 100% 100%, 0 100%, 0 28px);

        ${mq('m')} {
          clip-path: polygon(34px 0, 100% 0, 100% 100%, 0 100%, 0 34px);
        }
      }
    }

    &:hover .card__arrow {
      border-color: black !important;
    };

    .card__tag-line {
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: ${px2rem('6px')} ${px2rem('10px')};
      
      ${mq('m')} {
        gap: ${px2rem('8px')} ${px2rem('16px')};
        margin-bottom: ${getSpace('xxs')};
        justify-content: start;
      }

      &.hidden {
        &--desktop {
          display: flex;

          ${mq('m')} {
            display: none;
          }
        }
        &--mobile {
          display: none;

          ${mq('m')} {
            display: flex;
          }
        }
      }
      .card__tag {
        .filter-tag {
          padding: ${px2rem('3px')} ${getSpace('xs')};

          .filter-tag__title {
            font-size: ${px2rem('16px')};
          }
        }
      }
    }

    .card__image {
      ${mq('m')} {
        grid-column: span 2 / span 2;
      }
    }
    .card__content {
      display: flex;
      gap: ${px2rem('26px')};

      ${mq('m')} {
        grid-column: span 8 / span 8;
      }

      .card__text {
        width: 100%;
        
        .card__headline {
          font-size: ${px2rem('20px')};
        }
        .card__copy {
          margin: ${px2rem('5px')} 0 0 0;
          color: ${getColor('teaserGray')};
          line-height: 1.75;
        }
        .card__stretched-link {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
      .card__arrow {
        display: none;

        ${mq('m')} {
          border-left: 2px solid ${getColor('gray')};
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 ${getSpace('xxs')} 0 ${getSpace('s')};
        }
      }
    }
  }
`;

export default StyledEducationCard;
